<template>
  <v-responsive
    class="mx-auto"
    max-width="800"
  >
    <v-container class="pb-12 pt-2">
      <v-row>
        <v-col cols="12">
          <information-box />
        </v-col>
        <v-col cols="12">
          <v-alert
            class="ma-0"
            dense
            text
            type="warning"
            dismissible
          >
            Issues must be created with this form or they will be closed immediately.
          </v-alert>
        </v-col>
        <v-col cols="12">
          <new-issue-form />
        </v-col>
      </v-row>
    </v-container>
  </v-responsive>
</template>

<script>
  export default {
    name: 'IssueCreator',

    components: {
      InformationBox: () => import('./InformationBox'),
      NewIssueForm: () => import('./NewIssueForm'),
    },
  }
</script>
